import Cookies from "js-cookie";
import * as Sentry from "../../config/sentry";
class TenantMngtClient {
  constructor() {
    this.config = {
      headers: { Authorization: `Bearer ${this.directLineSecret}` },
    };
  }

  async recordInteraction({
    meetingId,
    interactionType,
    currentQuestion,
    message,
    interactor,
    startMarkerOffset,
  }) {
    try {
      const jwt = Cookies.get("jwt");
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL_2}/v1/assessment-sessions/${meetingId}/interactions/record`,
        {
          // const response = await fetch("/api/interact_with_bot", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": jwt,
          },
          body: JSON.stringify({
            type: interactionType,
            questionText: currentQuestion,
            message: message,
            timestamp: new Date().toISOString(),
            interactor,
            startMarkerOffset,
          }),
        }
      );

      let data = await response.json();
      return data;
    } catch (error) {
      console.error("[TenantMngtClient] Error in recordInteraction:", {
        error: error.message,
        meetingId,
        interactionType,
        interactor,
        status: error.response?.status,
        statusText: error.response?.statusText,
        url: `${process.env.REACT_APP_BASE_URL_2}/v1/assessment-sessions/${meetingId}/interactions/record`
      });
      Sentry.captureException(error);
      throw error;
    }
  }

  async endInteraction({ meetingId, interactionType, currentQuestion }) {
    try {
      const jwt = Cookies.get("jwt");
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL_2}/v1/assessment-sessions/${meetingId}/interactions/end`,
        {
          // const response = await fetch("/api/interact_with_bot", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": jwt,
          },
          body: JSON.stringify({
            type: interactionType,
            questionText: currentQuestion,
            timestamp: new Date().toISOString(),
          }),
        }
      );

      let data = await response.json();
      return data;
    } catch (error) {
      console.error("[TenantMngtClient] Error in endInteraction:", {
        error: error.message,
        meetingId,
        interactionType,
        status: error.response?.status,
        statusText: error.response?.statusText,
        url: `${process.env.REACT_APP_BASE_URL_2}/v1/assessment-sessions/${meetingId}/interactions/end`
      });
      Sentry.captureException(error);
      throw error;
    }
  }

  async endSession({ meetingId }) {
    try {
      const jwt = Cookies.get("jwt");
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL_2}/v1/assessment-sessions/${meetingId}/end`,
        {
          // const response = await fetch("/api/interact_with_bot", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "auth-token": jwt,
          },
        }
      );

      let data = await response.json();
      return data;
    } catch (error) {
      console.error("[TenantMngtClient] Error in endSession:", {
        error: error.message,
        meetingId,
        status: error.response?.status,
        statusText: error.response?.statusText,
        url: `${process.env.REACT_APP_BASE_URL_2}/v1/assessment-sessions/${meetingId}/end`
      });
      Sentry.captureException(error);
      throw error;
    }
  }
}

export default TenantMngtClient;
